import { useMediaQuery } from "react-responsive";

export const useScreenSize = () => {
  const isDesktop = useMediaQuery({ query: "(min-width: 1000px)" });

  return { isDesktop };
};
